import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "task-parameters-templates-list_wrapper" }
const _hoisted_2 = ["onMousemove"]
const _hoisted_3 = { class: "task-parameters-templates-list_item_title" }
const _hoisted_4 = { class: "task-parameters-form_button" }
const _hoisted_5 = { class: "task-parameters-templates-list_popover" }
const _hoisted_6 = { class: "task-parameters-templates-list_popover_buttons" }
const _hoisted_7 = { class: "task-parameters-form_button" }
const _hoisted_8 = { class: "task-parameters-templates-list_popover" }
const _hoisted_9 = { class: "task-parameters-templates-list_popover_buttons" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "task-parameters-templates-list_item_parameters" }

import { onMounted, onUnmounted, PropType, ref } from "vue";
import { ParametersTemplateModel, TaskParameterModel, TaskParameterTypeEnum } from "@/components";
import {
  PencilSquareIcon,
  TrashIcon,
  ArrowDownTrayIcon,
} from "tir-style-system/icons/outline";
import {
  PopoverPositionEnum,
  TirPmPopover,
  TirPmInput,
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  TirPmScrollbar,
} from "tir-components";
import { TaskParameter } from "@/components";

/**Параметры компонента */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-parameters-templates-list',
  props: {
  /**Тип настройки */
  type: { type: Number as PropType<TaskParameterTypeEnum> },
  /**Список шаблонов */
  templates: { type: Array as PropType<ParametersTemplateModel[]> },
  /**Весь список доступных параметров */
  templateParameters: { type: Array as PropType<TaskParameterModel[]> },
  /**Режим импорта параметров из очередей */
  isImport: { type: Boolean, default: false },
},
  emits: ["remove", "upsert", "select", "editCompound"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Элемент обертки */
const $wrapper = ref<HTMLElement>();
/**Максимально допустимая высота списка шаблонов */
const maxHeight = ref();
/**Имя шаблона */
const innerName = ref("");
/**Поповер редактирования шаблона */
const $editPopover = ref<InstanceType<typeof TirPmPopover>[]>();
/**Поповер удаления шаблона */
const $removePopover = ref<InstanceType<typeof TirPmPopover>[]>();
/**Индекс элемента под курсором */
const hoverIndex = ref();

/**После рендера */
onMounted(() => {
  window.addEventListener("resize", windowOnResize);
  windowOnResize();
});
/**Перед удалением */
onUnmounted(() => {
  window.removeEventListener("resize", windowOnResize);
});

/**При изменении размеров окна */
function windowOnResize() {
  const rect = $wrapper.value?.getBoundingClientRect();
  if (rect) {
    maxHeight.value = rect.height / 16 + "rem";
  }
}
/**Проверить, отключена ли кнопка сохранения имени шаблона */
const checkSaveDisable = (template: ParametersTemplateModel) => {
  return !innerName.value || innerName.value == template.Name;
};
/**Изменить имя шаблона */
const editTemplateName = (template: ParametersTemplateModel, index: number) => {
  template.Name = innerName.value;
  $editPopover.value[index]?.close?.();
  emit("upsert", template);
};
/**Начало редактирования состава шаблона */
const startEditTemplate = (template: ParametersTemplateModel, index: number) => {
  $editPopover.value[index]?.close?.();
  emit("editCompound", template);
};
/**Удаление шаблона */
const removeTemplate = (template: ParametersTemplateModel) => {
  emit("remove", template);
};
/**Закрыть поповер удаления шаблона */
const closeRemovePopover = (index: number) => {
  $removePopover.value[index]?.close?.();
};
/**Получение класса элемента списка */
const getItemClass = (index: number) => {
  return { hover: hoverIndex.value == index };
};
/**Установка hover индекса */
const setHoverIndex = (index: number) => {
  hoverIndex.value = index;
};
/**Выбор шаблона */
const selectTemplate = (template: ParametersTemplateModel) => {
  setTimeout(() => emit("select", template));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "task-parameters-templates-list",
    ref_key: "$wrapper",
    ref: $wrapper
  }, [
    _createVNode(_unref(TirPmScrollbar), null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_TransitionGroup, { name: "task-parameters-templates-list_animation" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.templates, (template, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: template.Id,
                  class: _normalizeClass(["task-parameters-templates-list_item", getItemClass(index)]),
                  onMousemove: ($event: any) => (setHoverIndex(index)),
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (setHoverIndex(undefined)))
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createTextVNode(_toDisplayString(template.Name) + " ", 1),
                    (!__props.isImport)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_unref(TirPmPopover), {
                            position: _unref(PopoverPositionEnum).Right,
                            ref_for: true,
                            ref_key: "$editPopover",
                            ref: $editPopover
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_4, [
                                _createVNode(_unref(PencilSquareIcon))
                              ])
                            ]),
                            content: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_unref(TirPmInput), {
                                  modelValue: innerName.value,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerName).value = $event)),
                                  isWithHint: false,
                                  label: "Название шаблона",
                                  placeholder: "Шаблон",
                                  ref_for: true,
                                  ref: "$nameInput"
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_unref(TirPmButton), {
                                    variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                                    size: _unref(TirPmButtonSizeEnum).Small,
                                    "is-disabled": checkSaveDisable(template),
                                    onClick: ($event: any) => (editTemplateName(template, index))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Сохранить ")
                                    ]),
                                    _: 2
                                  }, 1032, ["variant", "size", "is-disabled", "onClick"]),
                                  _createVNode(_unref(TirPmButton), {
                                    variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                                    size: _unref(TirPmButtonSizeEnum).Small,
                                    onClick: ($event: any) => (startEditTemplate(template, index))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Редактировать состав ")
                                    ]),
                                    _: 2
                                  }, 1032, ["variant", "size", "onClick"])
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["position"]),
                          _createVNode(_unref(TirPmPopover), {
                            position: _unref(PopoverPositionEnum).Right,
                            ref_for: true,
                            ref_key: "$removePopover",
                            ref: $removePopover
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(_unref(TrashIcon))
                              ])
                            ]),
                            content: _withCtx(() => [
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_unref(TirPmButton), {
                                    variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                                    size: _unref(TirPmButtonSizeEnum).Small,
                                    onClick: ($event: any) => (removeTemplate(template))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Удалить ")
                                    ]),
                                    _: 2
                                  }, 1032, ["variant", "size", "onClick"]),
                                  _createVNode(_unref(TirPmButton), {
                                    variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                                    size: _unref(TirPmButtonSizeEnum).Small,
                                    onClick: ($event: any) => (closeRemovePopover(index))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Отмена ")
                                    ]),
                                    _: 2
                                  }, 1032, ["variant", "size", "onClick"])
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["position"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (__props.isImport || hoverIndex.value == index)
                      ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                          key: 1,
                          size: _unref(TirPmButtonSizeEnum).Small,
                          variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                          class: "accept",
                          onClick: ($event: any) => (selectTemplate(template))
                        }, {
                          default: _withCtx(() => [
                            (__props.isImport)
                              ? (_openBlock(), _createBlock(_unref(ArrowDownTrayIcon), { key: 0 }))
                              : (_openBlock(), _createElementBlock("span", _hoisted_10, "Применить"))
                          ]),
                          _: 2
                        }, 1032, ["size", "variant", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template.ParsedData, (parameter, idx) => {
                      return (_openBlock(), _createBlock(_unref(TaskParameter), {
                        key: idx,
                        preview: "",
                        data: parameter,
                        type: __props.type
                      }, null, 8, ["data", "type"]))
                    }), 128))
                  ])
                ], 42, _hoisted_2))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 512))
}
}

})